import { motion } from "framer-motion";

const rows = [
  {
    name: "Capa 1 · Plataforma Estratégica",
    note: "El cimiento · se entrega primero",
    amount: "USD 9.000",
    accent: "#ffffff",
  },
  {
    name: "Capa 2 · Identidad y Activación",
    note: "La expresión · al aprobar la primera capa",
    amount: "USD 11.000",
    accent: "#ffffff",
  },
];

const MammaInversion = () => {
  return (
    <section
      id="inversion"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, hsl(220 69% 2%), hsl(217 61% 10%))",
      }}
    >
      <div className="container px-4 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-10"
        >
          <span
            className="text-sm font-semibold tracking-[0.25em] uppercase mb-4 block"
            style={{ color: "#7ab7fd" }}
          >
            La inversión
          </span>
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] mb-8">
            Lo que desbloquea
            <br />
            <span style={{ color: "#7ab7fd" }}>todo lo demás.</span>
          </h2>

          <div className="flex flex-col items-center">
            <span className="font-display text-5xl md:text-7xl lg:text-8xl font-bold text-white">
              USD 20.000
            </span>
            <p className="mt-4 text-base md:text-lg text-white/70">
              Sistema de marca completo — las dos capas
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="rounded-xl p-5 md:p-6 mb-12 border-l-4 max-w-3xl mx-auto"
          style={{ borderColor: "#7ab7fd", background: "rgba(122,183,253,0.06)" }}
        >
          <p className="text-sm md:text-base text-white/80 leading-relaxed">
            Ya invertiste en máquinas, en frío, en un local diseñado por
            arquitecto, en el armado de la franquicia. Todo eso rinde a media
            máquina mientras falte la marca que lo active.{" "}
            <span className="text-white font-medium">
              Cada mes sin cerrar una franquicia cuesta más que esto.
            </span>
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="rounded-3xl border border-white/10 overflow-hidden"
          style={{
            background: "linear-gradient(160deg, hsl(217 61% 10%), hsl(220 69% 4%))",
          }}
        >
          {/* Featured */}
          <div
            className="flex flex-wrap items-center justify-between gap-4 px-6 md:px-9 py-6 border-b border-white/10"
            style={{ background: "rgba(79,70,229,0.16)" }}
          >
            <div>
              <p className="font-display text-xl md:text-2xl font-semibold text-white">
                Sistema completo
              </p>
              <p className="text-xs md:text-sm text-white/55 mt-1">
                Las dos capas · el sistema de marca completo
              </p>
            </div>
            <p
              className="font-display text-2xl md:text-3xl font-bold whitespace-nowrap"
              style={{ color: "#8b87f5" }}
            >
              USD 20.000
            </p>
          </div>

          {rows.map((r) => (
            <div
              key={r.name}
              className="flex flex-wrap items-center justify-between gap-4 px-6 md:px-9 py-6 border-b border-white/10"
            >
              <div>
                <p className="font-display text-lg md:text-xl font-semibold text-white">
                  {r.name}
                </p>
                <p className="text-xs md:text-sm text-white/55 mt-1">{r.note}</p>
              </div>
              <p className="font-display text-xl md:text-2xl font-bold text-white whitespace-nowrap">
                {r.amount}
              </p>
            </div>
          ))}

          {/* Single payment */}
          <div
            className="flex flex-wrap items-center justify-between gap-4 px-6 md:px-9 py-7 border-b border-white/10"
            style={{ background: "rgba(122,183,253,0.08)" }}
          >
            <div>
              <p
                className="text-[11px] font-semibold tracking-[0.2em] uppercase mb-1"
                style={{ color: "#7ab7fd" }}
              >
                Opción preferencial
              </p>
              <p className="font-display text-lg md:text-2xl font-semibold text-white">
                Pago único del sistema completo
              </p>
              <p className="text-xs md:text-sm text-white/55 mt-1">
                10% de descuento sobre el total
              </p>
            </div>
            <p
              className="font-display text-2xl md:text-4xl font-bold whitespace-nowrap"
              style={{ color: "#7ab7fd" }}
            >
              USD 18.000
            </p>
          </div>

          <p className="px-6 md:px-9 py-6 text-sm text-white/60 leading-relaxed bg-black/20">
            Empezás por la primera capa, que es la que hace vendible tu franquicia.
            La segunda se activa cuando quieras avanzar —a tu ritmo, sin resignar
            profundidad.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default MammaInversion;
